import * as React from 'react'
import { ReactElement } from 'react'
import Tooltip from '../Tooltip'
import { AnyDate, applyLocalTimeZone, formatDateTime, parseDateTime, TimeFormats } from '../../helpers/dateHelper'
import { Text } from '@fluentui/react'

type Props = {
    date: AnyDate
}

export default function FormattedDateTime(props: Props): ReactElement {
    return (
        <Tooltip
            hostProps={{ content: applyLocalTimeZone(parseDateTime(props.date))?.toFormat(TimeFormats.Full) || '' }}
        >
            <Text variant="small" block nowrap>
                {formatDateTime(applyLocalTimeZone(props.date))}
            </Text>
        </Tooltip>
    )
}
